import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, notification } from 'antd';
import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { translate } from 'react-i18next';
import i18next from 'i18next';
import moment from 'moment';

import SearchBar from 'Parts/search/SearchBarContainer';
import PaginationTop from 'Parts/search/PaginationTop';
import Wysiwyg from '../../parts/ui/components/fields/Wysiwyg';
import { getLanguageDateFormatByKey } from '../../parts/common/langUtils';

import {
    UPDATE_MESSAGE_SUCCESS
} from '../../messages/messageActions';

import savedDraftsEN from './locales/SavedDrafts_en.json';
import savedDraftsFR from './locales/SavedDrafts_fr.json';

import './UserInbox.less';

const PAGE_SIZE = 10;
const ACTIVE = 1;
const ARCHIVED = 3;

class SavedDrafts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pager: {
                total: props.pagination ? props.pagination.totalResults : 0,
                current: props.pagination ? props.pagination.pageNumber : 1,
                pageSize: PAGE_SIZE
            },
        }

        i18next.addResourceBundle('en', 'SavedDrafts', savedDraftsEN);
        i18next.addResourceBundle('fr', 'SavedDrafts', savedDraftsFR);

        this.deselectMessage = this.deselectMessage.bind(this);
        this.refreshList = this.refreshList.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Update the pager with the new total
        let pager;

        if (this.props.pagination && (!prevProps.pagination || prevProps.pagination.pageNumber !== this.props.pagination.pageNumber || 
            prevProps.pagination.totalResults !== this.props.pagination.totalResults)) {
            pager = {
                ...this.state.pager,
                total: this.props.pagination.totalResults,
                current: this.props.pagination.pageNumber,
                pageSize: PAGE_SIZE
            };

            this.setState({ pager });
        }

        if(this.props.fetchTime && (!prevProps.fetchTime || prevProps.fetchTime !== this.props.fetchTime)) {
            this.setState({ drafts: this.props.drafts, fetchTime: this.props.fetchTime })
        }
    }

    render() {
        const { t, drafts, form, message, locale } = this.props;

        let messageList = drafts && drafts.length > 0 && (drafts.map((m) => 
            <div className="message-box clickable" onClick={() => {
                    this.setState({selectedMessage: m})
                    this.wysiwygContent = m.content;
                    this.props.getMessage(m.id)
                }}>
                <div className="message-box-content">
                    <span className="message-box-text">{t("Subject") + ": " + m.subject}</span>
                    <span className="message-box-text">{t("Date") + ": " + moment(m.sentOn).format(getLanguageDateFormatByKey(locale))}</span>
                </div>
                <button className="ant-btn ant-btn-primary full-button message-box-button">
                    <FontAwesomeIcon icon={faTrash} title={t('Discard Draft')} onClick={(e) => { this.discardDraft(e, m.id) }}/>
                </button>
            </div>
        ))


        let recipientArea = [];

        if (message && message.recipients && message.recipients.length > 0) {
                message.recipients.map((r, i) => {
                    if(i > 0)
                        recipientArea.push(<div className="recipient">-</div>);
                    recipientArea.push(<div className='recipient'>{"[" + (i + 1) + "] " + r.name}</div>)
                })
        } else
            recipientArea.push(<div className='recipient'>{t('No recipients')}</div>)

        let messageArea = drafts && drafts.length > 0 ? (
            <div className="message-area">
                <div className={"message-list" + (this.state.selectedMessage ? " convo-selected" : '')}>
                    {messageList}
                </div>
                {this.state.selectedMessage ? 
                    <div className={'selected-message-area convo-selected'}>
                        <button className="ant-btn back-button" onClick={this.deselectMessage}>
                            <FontAwesomeIcon icon={['fal', 'long-arrow-left']} className='back-arrow'/>
                        </button>
                        <div className="subject-span"><span>{t('Subject') + ": " + this.state.selectedMessage.subject}</span></div>
                        <Wysiwyg 
                            fieldId={"edit_" + this.state.selectedMessage.id} 
                            className="message-content" 
                            onChange={(e) => {this.wysiwygContent = e}}
                            maxlength={2048}
                            required={true}
                            accentColors={this.props.accentColors}
                            form={form}
                            initialValue={this.state.selectedMessage.content}
                            allowAllTags={true}
                        />
                         {message.canSendEmails && <div className='checkbox-area'>
                                        <Checkbox 
                                            id={'chk_send_emails'}
                                            initialValue={false}
                                            onChange={this.handleCheckChange}
                                        >{t('SendEmails')}</Checkbox>
                                    </div>}
                        <div className="reply-area">
                            <button className={'ant-btn ant-btn-primary'} onClick={() => {this.confirmSend()}}>{t('Send')}</button>
                        </div>
                        <div className="recipient-zone">
                            <b>{t("Recipient List", { count: message && message.recipients ? message.recipients.length : 0 })}</b>
                            <div className='recipient-area flex'>{recipientArea}</div>
                        </div>
                    </div>
                    :
                    <div className='selected-message-area'>
                        <h1 className="no-selected">{t('No selected message')}</h1>
                    </div>
                }
            </div>
        ) : <h1>{t('no_drafts')}</h1>

        return (
            <div className="SavedDrafts">
                <SearchBar 
                    placeholder={t('Search')} 
                    onSearch={this.handleSearch}
                />
                <div className="SavedDrafts__Content">
                    <PaginationTop
                        totalLabel={total => t('messagesTotal', { count: this.state.pager.total })}
                        pager={this.state.pager}
                        onChange={this.handlePaginationChange}
                        showSizeChanger={false}
                    />
                    {messageArea}
                </div>
            </div>
        )
    }

    handlePaginationChange = pager => {
        if(this.props.isUpdateMessageInProgress)
            return;
        this.setState({ pager }, this.refreshList);
    };
    
    handleSearch = filters => {
        if(this.props.isUpdateMessageInProgress)
            return;
        
        this.setState({search: filters.search})

        this.refreshList();
    }

    refreshList() {
        const pagination = {
            pageNumber: this.state.pager.current,
            pageSize: PAGE_SIZE,
            totalResults: this.state.pager.total
        };

        this.props.searchDrafts(this.props.platformId, this.state.search, null, pagination, { orderBy: 'addedOn[desc]' }, true);
    }

    deselectMessage() {
        if(this.props.isUpdateMessageInProgress)
            return;
        this.setState({
            selectedMessage: undefined
        });
    }

    confirmSend() {
        let content = this.wysiwygContent;
        if(!content || content.length === 0) {
            return notification.error({
                message: this.props.t('Missing content'),
                description: this.props.t('Please give content to your message')
            })
        }
        this.props.updateMessage(this.state.selectedMessage.id, ACTIVE, content, this.state.send_emails).then((e) => {
            if (e.type === UPDATE_MESSAGE_SUCCESS) {
                this.setState({
                    selectedMessage: undefined
                }, this.refreshList)
            }
        })
    }

    discardDraft(e, messageId) {
        e.stopPropagation();
        if(confirm(this.props.t('Confirm delete draft'))) { 
            this.props.updateMessage(messageId, ARCHIVED, undefined).then((e) => {
                if (e.type === UPDATE_MESSAGE_SUCCESS) {
                    if(messageId === this.state.selectedMessage.id) {
                        this.setState({
                            selectedMessage: undefined
                        }, this.refreshList)
                    } else
                        this.refreshList();
                }
            })
        }
    }

    handleCheckChange(e) {
        this.setState({
            send_emails: e.target.checked
        })
    }
}

export default translate('SavedDrafts')(SavedDrafts);